/** Киргизский язык — формы заказа, контакты */
export const formsKy: Record<string, string> = {
  "order.service.audit_free": "Акысыз DevOps аудити (30 мүнөттүү чалуу)",
  "order.service.starter_devops": "Starter DevOps — $1,500/айына (30 саат, SLA 8с)",
  "order.service.growth_devops": "Growth DevOps — $3,000/айына (80 саат, SLA 4с) 🏆",
  "order.service.enterprise_devops": "Enterprise DevOps — $5,000/айына (160 саат, SLA 1с)",
  "order.service.k8s_setup": "Kubernetes Setup — $3,000–7,000 (бир жолку)",
  "order.service.k8s_managed": "Kubernetes Managed — $500/айына баштап",
  "order.service.vps_hosting": "VPS-хостинг — $7.62/айына баштап (CX23, биллинг)",
  "order.service.devops_estimate": "DevOps баасын баалоо",
  "order.service.ddos_protection": "DDoS коргоо",
  "order.service.cicd_implementation": "CI/CD киргизүү",
  "order.service.llmops_private_ai": "LLMOps & Private AI — под ключ долбоор (Fixed Price)",
  "order.service.devops_general": "DevOps аутсорсинг (жалпы суроо)",
  "order.service.support_247": "Серверлерди колдоо 24/7 (жалпы суроо)",

  "order.pageTitle": "DevOps-инфраструктуранын акысыз аудити",
  "order.pageSubtitle":
    "IT-инфраструктураңыздын кеңири талдоосун алыңыз жана DevOps аутсорсинг биринчи айынан тартып чыгымдарды 60%га азайта аларын билиңиз",
  "order.formTitle": "Акысыз DevOps аудити формасы",
  "order.formIntro":
    "Эки талаа — биз сиз менен байланышабыз. Узун анкеталар жана милдеттүү талаптар жок.",
  "order.label.name": "Аты *",
  "order.label.email": "Email *",
  "order.label.phone": "Телефон",
  "order.label.company": "Компания",
  "order.label.service": "Кызыктырган кызмат *",
  "order.label.projectType": "Долбоор түрүн тандаңыз *",
  "order.label.contact": "Байланыш үчүн Telegram / WhatsApp *",
  "order.label.message": "Билдирүү",
  "order.ph.name": "Сиздин атыңыз",
  "order.ph.email": "your@email.com",
  "order.ph.phone": "+996",
  "order.ph.company": "Компаниянын аталышы",
  "order.ph.service": "Кызматты тандаңыз",
  "order.ph.projectType": "Долбоор түрүн тандаңыз",
  "order.ph.contact": "@username же +996 XXX XXX XXX",
  "order.ph.message": "Милдеттериңизди же көйгөйлөрүңүздү сүрөттөп бериңиз...",
  "order.hint.contact": "15 мүнөттүү стек талдоосун милдеттүү талапсыз жүргүзөбүз.",
  "order.submit": "Акысыз талдоо алуу",
  "order.sending": "Жөнөтүлүүдө...",
  "order.successTitle": "Инфраструктуранын аудити заказдалды!",
  "order.successText":
    "Рахмат! Сиздин өтүнүч кабыл алынды. DevOps адисибиз 24 сааттын ичинде байланышат — акысыз аудит жүргүзүү жана потенциалдык үнөмдөөнү эсептөө үчүн.",
  "order.successAgain": "Дагы бир аудит заказдоо",
  "order.mailtoFallback":
    "Почта клиенти ачылган жок. Email же Telegram аркылуу жазыңыз — 24 саат ичинде жооп беребиз.",
  "order.backServices": "Кызматтарга кайтуу",
  "order.contactTitle": "Биз менен байланышыңыз",
  "order.contactEmail": "Email",
  "order.contactTg": "Telegram",
  "order.contactPhone": "Телефон",
  "order.benefitsTitle": "Эмне аласыз?",
  "order.benefit1": "✅ Инфраструктуранын кеңири талдоосу",
  "order.benefit2": "✅ Потенциалдык үнөмдөөнү эсептөө",
  "order.benefit3": "✅ Оптимизация боюнча сунуштар",
  "order.benefit4": "✅ DevOps киргизүү планы",
  "order.benefit5": "✅ Кызматтардын баасын баалоо",
  "order.responseTitle": "Жооп берүү убактысы",
  "order.responseText":
    "Бардык өтүнүчтөргө иш убактысында (Дж-Жм, 9:00-18:00 Бишкек убактысы) 2 сааттын ичинде жооп беребиз.",
  "order.mail.subject": "IT-24.pro сайтынан жаңы заказ",
  "order.mail.infoSubject": "DevOps кызматтары боюнча маалымат суроо",
  "order.mail.bodyTitle": "🔔 IT-24.pro сайтынан жаңы заказ",
  "order.mail.name": "👤 Аты",
  "order.mail.email": "📧 Email",
  "order.mail.phone": "📱 Телефон",
  "order.mail.contact": "💬 Telegram / WhatsApp",
  "order.mail.company": "🏢 Компания",
  "order.mail.service": "🛠️ Кызмат",
  "order.mail.message": "💬 Билдирүү",
  "order.mail.time": "⏰ Убакыт",
  "order.mail.na": "Көрсөтүлгөн эмес",
  "order.mail.naF": "Көрсөтүлгөн эмес",
  "order.mail.naMsg": "Көрсөтүлгөн эмес",
  "order.errorSend": "Жөнөтүүдө ката кетти. Кийинчерээк аракет кылыңыз же түз байланышыңыз.",

  "contacts.title": "Биз менен байланышыңыз",
  "contacts.subtitle":
    "Проектиңизди талкууга даярсызбы? Байланыштын ыңгайлуу жолун тандаңыз же кайрымдуулук формасын толтуруңуз",
  "contacts.card.phoneTitle": "Телефон",
  "contacts.card.phoneDesc":
    "Жандуу баарлашууну жактырасызбы? Суроолорду тез талкуулоо жана кийинки кадамдарды келишүү үчүн чалыңыз.",
  "contacts.card.mailTitle": "Электрондук почта",
  "contacts.card.mailDesc":
    "Милдеттериңизди же көйгөйлөрүңүздү сүрөттөп жазыңыз. Биз тез жооп беребиз жана чечим сунуштайбыз.",
  "contacts.card.tgTitle": "Telegram",
  "contacts.card.tgDesc":
    "Тез жооп жана дароолук колдоо үчүн Telegram аркылуу жазыңыз!",
  "contacts.card.formTitle": "Кайрымдуулук формасы",
  "contacts.card.formValue": "Онлайн өтүнүч",
  "contacts.card.formDesc":
    "Тез жооп алуу үчүн сайттагы форманы толтуруңуз. Байланыш маалыматтарыңызды жана кыскача сүрөттөөңүздү көрсөтүңүз.",
  "contacts.formTitle": "Кайрымдуулук формасы",
  "contacts.label.subject": "Тема *",
  "contacts.ph.subject": "Билдирүү темасы",
  "contacts.ph.message": "Милдеттериңизди же суроолоруңузду сүрөттөп бериңиз...",
  "contacts.send": "Билдирүү жөнөтүү",
  "contacts.successTitle": "Билдирүү жөнөтүлдү!",
  "contacts.successText": "Билдирүүңүз үчүн рахмат! Биз кабыл алдык жана эң жакын арада байланышабыз.",
  "contacts.sendAgain": "Дагы бир билдирүү жөнөтүү",
  "contacts.hoursTitle": "Иш сааттары",
  "contacts.hoursNote": "⚡ Критикалык инциденттер үчүн 24/7 шашылыш колдоо жеткиликтүү",
  "contacts.addrTitle": "Дарек",
  "contacts.addrLine": "Кыргызстан, Бишкек",
  "contacts.addrNote": "Бүт Кыргызстан жана КМШ өлкөлөрү боюнча алыстан иштейбиз",
  "contacts.sosTitle": "🚨 Шашылыш колдоо",
  "contacts.sosText": "Критикалык инцидентби? Дароолук жардам керекпи?",
  "contacts.sosCall": "Шашылыш чалуу",
  "contacts.sosTg": "Telegram SOS",
  "contacts.mail.subjectPrefix": "IT-24.pro сайтынан билдирүү:",
  "contacts.mail.bodyTitle": "🔔 IT-24.pro сайтынан жаңы билдирүү",
  "contacts.mail.subjectLine": "📋 Тема",
  "contacts.subjectForService": "Кызмат боюнча суроо",
  "contacts.day1": "Дүйшөмбү — Жума",
  "contacts.day2": "Ишемби",
  "contacts.day3": "Жекшемби",
  "contacts.time1": "9:00 — 18:00",
  "contacts.time2": "10:00 — 16:00",
  "contacts.time3": "Келишим боюнча",
};
